/**
 * @description Loads intl polyfill and locale data if there is no window.Intl
 */
export async function clientIntlPolyfill(): Promise<void> {
    if (!window.Intl.PluralRules) {
        await import(
            /* webpackChunkName: "intlClientPolyfillPluralRules" */ '../src/intl/polyfills/pluralRules.js'
        );
    }
    if (!window.Intl.ListFormat) {
        await import(
            /* webpackChunkName: "intlClientPolyfillListFormat" */ '../src/intl/polyfills/listFormat.js'
        );
    }
}
